export default "https://d1e6s5z4lzmgxx.cloudfront.net/6e52c691-29e3-4541-bed6-a97355993ecd/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";